import MoonAtsActivityOverview from './MoonAtsActivityOverview'
// Uncomment the below to migrate to stateful component
// import MoonAtsActivityOverviewContainer from './MoonAtsActivityOverviewContainer'

export { MoonAtsActivityOverview }
export default MoonAtsActivityOverview
// Uncomment the below to migrate to stateful component
// export { MoonAtsActivityOverviewContainer }
// export default { MoonAtsActivityOverviewContainer }
